module.exports = __webpack_public_path__ + "static/media/af.a831c716.png";